import { render } from "./Nav.vue?vue&type=template&id=b5458be8&scoped=true&ts=true"
import script from "./Nav.vue?vue&type=script&lang=ts"
export * from "./Nav.vue?vue&type=script&lang=ts"

import "./Nav.vue?vue&type=style&index=0&id=b5458be8&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5458be8"]])

export default __exports__